/* FeedbackForm.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./FeedbackForm.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
/** @jsxfrag */
import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import ThumbsDownIcon from '@atlaskit/icon/core/thumbs-down';
import ThumbsUpIcon from '@atlaskit/icon/core/thumbs-up';
import { Box } from '@atlaskit/primitives/compiled';
import VisuallyHidden from '@atlaskit/visually-hidden';
import messages from './messages';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var hideBackgroundStyles = null;
var Announcer = function Announcer(_ref) {
  var message = _ref.message,
    shouldAnnounce = _ref.shouldAnnounce;
  return /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(Box, {
    "aria-atomic": "true",
    "aria-live": "polite"
  }, shouldAnnounce && message));
};
var FeedbackButton = function FeedbackButton(_ref2) {
  var type = _ref2.type,
    onClick = _ref2.onClick,
    isPressed = _ref2.isPressed,
    isDisabled = _ref2.isDisabled;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var responseLabel = type === 'good' ? formatMessage(messages.goodResponse) : formatMessage(messages.badResponse);
  var color = isPressed ? "var(--ds-link-pressed, #0055CC)" : 'currentColor';
  var Icon = function Icon() {
    return type === 'good' ? /*#__PURE__*/React.createElement(ThumbsUpIcon, {
      label: responseLabel,
      color: color
    }) : /*#__PURE__*/React.createElement(ThumbsDownIcon, {
      label: responseLabel,
      color: color
    });
  };
  var tooltipOptions = {
    position: 'top',
    content: responseLabel
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ax([(isPressed || isDisabled) && "_7dirsm61"])
  }, /*#__PURE__*/React.createElement(IconButton, {
    testId: "".concat(type, "-response-feedback-button"),
    type: "button",
    isDisabled: isDisabled,
    onClick: onClick,
    icon: Icon,
    label: responseLabel,
    appearance: "subtle",
    spacing: "compact",
    isTooltipDisabled: false,
    tooltip: tooltipOptions
  }));
};
export var FeedbackForm = function FeedbackForm(_ref3) {
  var onGoodResponseButtonClick = _ref3.onGoodResponseButtonClick,
    onBadResponseButtonClick = _ref3.onBadResponseButtonClick,
    isPressed = _ref3.isPressed,
    isDisabled = _ref3.isDisabled;
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var feedbackWasSentLabel = formatMessage(messages.feedbackSent);
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    feedbackSelected = _React$useState2[0],
    setFeedbackSelected = _React$useState2[1];
  var handleOnClick = React.useCallback(function (onClick, feedback) {
    return function () {
      onClick();
      setFeedbackSelected(feedback);
    };
  }, [setFeedbackSelected]);
  var disableButton = !!isPressed || isDisabled || !!feedbackSelected;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Announcer, {
    message: feedbackWasSentLabel,
    shouldAnnounce: Boolean(feedbackSelected)
  }), /*#__PURE__*/React.createElement(FeedbackButton, {
    type: "good",
    isPressed: isPressed === 'good',
    isDisabled: disableButton,
    onClick: handleOnClick(onGoodResponseButtonClick, 'good')
  }), /*#__PURE__*/React.createElement(FeedbackButton, {
    type: "bad",
    isPressed: isPressed === 'bad',
    isDisabled: disableButton,
    onClick: handleOnClick(onBadResponseButtonClick, 'bad')
  }));
};